export const tooltips = {
  zakladniSpecifikace: {
    typOpravneni: 'Jedná se o povinné pole. Výběr typu oprávnění, pro které bude daná šablona využívána.',
    platnostOd:
      'Tato pole je možné použít různými způsoby a pomocí kombinace těchto polí se dají šablony vyhledat podle následujících specifikovaných omezení.',
    nazev: 'Jedná se o povinné pole. Zadejte prosím název šablony. ',
    // jePostupitelne
    // jePrezidialnePostupitelne
    opravneniKZastupovani:
      'Jedná se o povinné pole pro explicitní typ oprávnění. Uživatel definuje, kde je možné vytvořit nové oprávnění k zastupování dle dané šablony. ',
    zastupovanehoNasobne:
      'Uživatel pomocí zaškrtávacího pole definuje, zda je možné zastupovaného definovat násobně (neboli je možné hromadně vytvořit oprávnění k zastupování pro větší počet zastupovaných). ',
    roleZastupovaneho: 'Při psaní našeptávač zobrazuje seznam existujících rolí.',
    zastupujicihoNasobne:
      'Uživatel pomocí zaškrtávacího pole definuje, zda je možné zastupujícího definovat násobně (neboli je možné hromadně vytvořit oprávnění k zastupování pro větší počet zastupujících). ',
    roleZastupujiciho: 'Při psaní našeptávač zobrazuje seznam existujících rolí.',
    popis: 'Pole pro vložení popisu',

    definovatRoliZastupovaneho: {
      nazev: 'Jedná se o povinné pole. Zadejte prosím název role.',
    },

    definovatRoliZastupujiciho: {
      nazev: 'Jedná se o povinné pole. Zadejte prosím název role.',
    },
  },
  omezeniNaSluzbyVs: {
    definovatNazevOmezeniSkupin: {
      nazev: 'Vyhledají se pouze šablony, které odpovídají názvu definovanému uživatelem.',
    },
    zobrazitUzivateliPouzePopis:
      'Jedná se o zaškrtávací pole. Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování se uživateli bude zobrazovat pouze uvedený popis omezení. Uživateli se nebudou zobrazovat všechny definované skupiny omezení.',

    popis: 'Pole pro vložení popisu',
    omezitSkupinuNaKonkretniOVM:
      'Uživatel může omezit skupinu na konkrétní OVM. V případě, že zde není vyplněno žádné OVM, je skupina dostupná všem OVM. Je možnost omezit na více OVM pomocí tlačítka přidat OVM.',
    uzivatelMuzeSkupinuOmezit:
      'Jedná se o zaškrtávací pole. Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování může sám uživatel definovat konkrétní OVM, pro které bude dané oprávnění platit. Pokud je tato položka zatrhnuta, nelze definovat OVM v konkrétní skupině omezení.',
    skupinaOmezeni: {
      volitelnostSkupiny: `Definuje skupiny omezení, které se vztahují k šabloně, podle které budou sestavována jednotlivá oprávnění.

Musí být vyplněna alespoň jedna skupina omezení s jednou agendou, aby šla šablona sestavit
`,
      zobrazitUzivateliPouzePopis: `Jedná se o zaškrtávací pole. Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování může sám uživatel definovat konkrétní OVM, pro které bude dané oprávnění platit.

Pokud je tato položka zatrhnuta, nelze definovat OVM v konkrétní skupině omezení.
`,
      popis: 'Pole pro vložení popisu',

      definovatParametry: {
        agenda: 'Oprávnění k zastupování můžou být omezena jen v rámci konkrétní agendy.',
        sluzba: 'Oprávnění k zastupování můžou být omezena v rámci agendy a konkrétní služby.',
        ukon: 'Oprávnění k zastupování můžou být omezena v rámci agendy, služby a konkrétního úkonu.',
      },
    },
  },
  ostatniOmezeni: {
    pridatSpecifickeOmezeni: {
      nazev: 'Název objektu, kterého se dané oprávnění k zastupování týká. Například: Silniční vozidlo.',
    },
    volitelnostSkupiny: 'Povinné pole. Jedná se o výběr z rozbalovacího seznamu.',
    zobrazitUzivateliPouzePopis: `Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování může sám uživatel definovat konkrétní OVM, pro které bude dané oprávnění platit.

Pokud je tato položka zatrhnuta, nelze definovat OVM v konkrétní skupině omezení.`,
    popis: 'Pole pro vložení popisu.',
    vybratZExistujicich: {
      kodNazev:
        'Identifikátor objektu. V případě objektu „Silniční vozidlo“ identifikátorem může být „Registrační značka“ nebo „VIN“.',
    },
    table: {
      popis: 'Textový popis',
      editovat: {
        nazev: 'Povinné pole. Zadejte název omezení.',
        popis: 'Textový popis',
      },
    },
    lzeDefinovatVolnaOmezeni:
      'Zaškrtávací pole „Lze definovat volná omezení“. Pokud je pole zaškrtnuté, je možné u oprávněních k zastupování vytvořených z dané šablony vyplnit volná omezení.',
    lzeDefinovatLokalniOmezeni:
      'Zaškrtávací pole „Lze definovat lokální omezení“. Pokud je pole zaškrtnuté, je možné u oprávněních k zastupování vytvořených z dané šablony vyplnit lokální omezení. ',
  },
  objekty: {
    nazev: 'Definujte název objektu.',
    vazbaNaRPP:
      'Volitelné pole, které tvůrce šablony může vyplnit zadáním kódem objektu z RPP nebo textem. Jestliže tvůrce šablony přiřadí nový objekt na objekt z RPP ovlivní to následně sekci Identifikátor.',
    vybratObjekt: {
      kodNazev: 'Tvůrce šablony může vyhledat již existující objekt.',
    },
    pridatObjekt: {
      nazev: 'Definujte název objektu.',
    },
    volitelneUzivatelem:
      'Zatrhávací tlačítko, které ovlivňuje, jestli pří zápisu/postoupení OKZ přes ISSS bude možné vložit identifikátor nebo identifikátory. Pokud je v objektu více identifikátorů, musí se při sestavení OKZ využít všechny.',
    lzeDefinovatNasobne:
      'Zatrhávací tlačítko, které ovlivňuje, jestli pří zápisu/postoupení OKZ přes ISSS bude možné vložit objekt opakovaně. Pokud je v objektu více identifikátorů, musí se při sestavení OKZ využít všechny.',
    popis: 'Pole pro vložení popisu',
    urlProOvereniExistenceObjektu:
      'URL adresa, kde může schvalovatel šablony ověřit, že definovaný objekt opravdu existuje a je správné objekt do REZA zakládat.',
    urlProOvereniExistenceSeznamuObjektu:
      'URL adresa, kde může schvalovatel šablony ověřit, že definovaný seznam objektu opravdu existuje a je správné seznam objektu do REZA zakládat.',
    vybratZExistujicich: {
      kodNazev: '',
    },
    definovatIdenifikator: {
      volitelneUzivatelem: 'Při vytvoření OKZ bude tento identifikátor povinný nebo nepovinný.',
      nazev: 'Tvůrce šablony definuje název Identifikátoru objektu.',
      kodANazevUdajeDleRPP:
        'Tvůrce šablony do našeptávače zadá kód údaje z RPP nebo přímo slovní název a vybere jednu z nabízených možností. ',
      popis: 'Textový popis',
      typ: 'Typ identifikátoru.',
      format: 'Povinné pole, pokud uživatel vyplní Typ.',
    },
    table: {
      popis: 'Textový popis',
      editovat: {
        volitelneUzivatelem: '',
        nazev: '',
        kodANazevUdajeRPP: '',
        popis: '',
        typ: '',
        format: '',
      },
    },
  },
  editor: {
    kodNazev:
      'Je nutné definovat jednu hlavní kategorii OVM. Je možné dohledávat jak pomocí kódu OVM, tak i názvu OVM. ',
    pridatKonkretnihoEditora: {
      vyberteUzivatele: 'Definujte konkrétní osobu editora šablony.',
    },
  },
  poskytovatelStanoviska: {
    kodNazev:
      'Je nutné definovat jednu hlavní kategorii OVM. Je možné dohledávat jak pomocí kódu OVM, tak i názvu OVM. ',
    pridatTypStanoviska: {
      nazev: 'Definujte konkrétní název typu stanoviska.',
    },
    pridatKonkretnihoPoskytovatele: {
      vyberteUzivatele: 'Definujte konkrétní osobu poskytovatele stanoviska.',
    },
  },
  nahled: {
    zastup: {
      zastupovany:
        'Uživatel pomocí zaškrtávacího pole definuje, zda je možné zastupovaného definovat násobně (neboli je možné hromadně vytvořit oprávnění k zastupování pro větší počet zastupovaných). ',
      zastupujici:
        'Uživatel pomocí zaškrtávacího pole definuje, zda je možné zastupujícího definovat násobně (neboli je možné hromadně vytvořit oprávnění k zastupování pro větší počet zastupujících). ',
    },
    omezeniNaSluzbyVS: {
      zobrazitPouzePopisOmezeni:
        'Jedná se o zaškrtávací pole. Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování se uživateli bude zobrazovat pouze uvedený popis omezení. Uživateli se nebudou zobrazovat všechny definované skupiny omezení.',
      uzivatelMuzeSkupinuOmezit:
        'Jedná se o zaškrtávací pole. Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování může sám uživatel definovat konkrétní OVM, pro které bude dané oprávnění platit. Pokud je tato položka zatrhnuta, nelze definovat OVM v konkrétní skupině omezení.',
    },
    specifickaOmezeni: {
      volitelnostSkupiny: 'Povinné pole. Jedná se o výběr z rozbalovacího seznamu.',
      zobrazitPouzePopisSkupinyOmezeni: `Pokud bude pole zaškrtnuté, při sestavování oprávnění k zastupování může sám uživatel definovat konkrétní OVM, pro které bude dané oprávnění platit.

Pokud je tato položka zatrhnuta, nelze definovat OVM v konkrétní skupině omezení.`,
      table: {
        popis: 'Textový popis',
      },
      volnaOmezeni:
        'Zaškrtávací pole „Lze definovat volná omezení“. Pokud je pole zaškrtnuté, je možné u oprávněních k zastupování vytvořených z dané šablony vyplnit volná omezení.',
      lokalniOmezeni:
        'Zaškrtávací pole „Lze definovat lokální omezení“. Pokud je pole zaškrtnuté, je možné u oprávněních k zastupování vytvořených z dané šablony vyplnit lokální omezení.',
    },
    editor: {
      kodNazev:
        'Je nutné definovat jednu hlavní kategorii OVM. Je možné dohledávat jak pomocí kódu OVM, tak i názvu OVM. ',
    },
    poskytovatelStanoviska: {
      kodNazev:
        'Je nutné definovat jednu hlavní kategorii OVM. Je možné dohledávat jak pomocí kódu OVM, tak i názvu OVM. ',
    },
  },
  role: {
    nazev: 'Zadejte název role, kterou bude moci uživatel použít v rámci vytvoření šablony oprávnění k zastupování.',
    popis: 'Pole pro vložení popisu role.',
  },
};
